const taskExistsOnServer = task => task.serverId

export default taskExistsOnServer